// forked from prosemirror-dev-tools
export const jsonTreeTheme = {
  scheme: 'monokai',
  base00: '#1E1E2E',
  base01: '#45475A',
  base02: '#313244',
  base03: '#B4BEFE',
  base04: '#F2CDCD',
  base05: '#CDD6F4',
  base06: '#CDD6F4',
  base07: '#CDD6F4',
  base08: '#F38BA8',
  base09: '#FAB387',
  base0A: '#F9E2AF',
  base0B: '#A6E3A1',
  base0C: '#94E2D5',
  base0D: '#89DCEB',
  base0E: '#CBA6F7',
  base0F: '#FAB387',
};

export const mainTheme = {
  main: '#CBA6F7',
  main20: 'rgba(203, 166, 247, .2)',
  main40: 'rgba(203, 166, 247, .4)',
  main60: 'rgba(203, 166, 247, .6)',
  main80: 'rgba(203, 166, 247, .8)',
  main90: 'rgba(203, 166, 247, .9)',
  mainBg: '#1E1E2E',
  softerMain: '#B4BEFE',

  white: '#fff',

  text: '#CDD6F4',
  white05: 'rgba(205, 214, 244, .05)',
  white10: 'rgba(205, 214, 244, .1)',
  white20: 'rgba(205, 214, 244, .2)',
  white60: 'rgba(205, 214, 244, .6)',
  white80: 'rgba(205, 214, 244, .8)',

  black30: '#11111B',

  // For diffs and structure
  lightYellow: 'rgba(205, 214, 244, .2)',
  lightPink: '#F38BA8',
  darkGreen: '#A6E3A1',

  syntax: jsonTreeTheme,
};
